import { useArtworkForm } from "@design-lab/entities/artwork";
import { useCurrentComposition } from "@design-lab/entities/composition";
import { usePlacementPosition } from "./usePlacementPosition";

export function useArtboard() {
  const { lens } = useArtworkForm();
  const placementLens = lens.focus("currentPlacement");
  const { placement } = usePlacementPosition(placementLens);
  const { currentComposition, previewComposition } = useCurrentComposition();

  // Use preview composition if available (when hovering), otherwise use current
  const composition = previewComposition || currentComposition;

  return { composition, placement };
}
